
import {Vue, Prop, Component} from 'vue-property-decorator'
@Component({
  components: {

  }
})
export default class CreatePassengerGroup extends Vue {
  
  @Prop({default: ''}) oraganizationId: string;

  newPassengerGroup = {
    Name: '',
    Description: '',
    OrganizationId: '',
  }

  closeDialog() {
    this.$emit('closeDialog')
    this.resetForm();
  }

  async createPassengerGroup() {
    this.newPassengerGroup.OrganizationId = this.oraganizationId;
    await this.$store.dispatch('organization/createPassengerGroup', { data: this.newPassengerGroup });
    this.$emit('closeDialog')
    this.resetForm();
    
  }

  resetForm() {
    this.newPassengerGroup.Name = '';
    this.newPassengerGroup.Description = '';
    this.newPassengerGroup.OrganizationId = '';
  }
}
